import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'

import Layout from '../components/Layout'

function SitemapV3() {
  const data = useStaticQuery(graphql`
    query {
      contentfulSiteMapModel(siteMapTitle: { eq: "Sitemap" }) {
        siteMapTitle
        siteMapSection {
          categoryTitle
          siteMapSubentry {
            pageTitle
            pageUrl
          }
        }
        seo {
          ...CustomSEOFragment
        }
      }
    }
  `)
  const dropInHeader = React.createRef()

  const {
    contentfulSiteMapModel: { siteMapTitle, siteMapSection, seo }
  } = data

  const {
    canonicalUrl,
    seoRobots,
    seoDescription,
    pageTitle,
    openGraphImage,
    openGraphTitle,
    openGraphDescription
  } = seo || {}
  const openGraph = {
    title: openGraphTitle,
    description: openGraphDescription?.openGraphDescription,
    image: openGraphImage
  }
  const metaRobots = seoRobots
  const metaDescription = seoDescription?.seoDescription

  const titles = siteMapSection.map(title => {
    const subInfo = title.siteMapSubentry.map(subtitle => (
      <li key={subtitle.pageTitle}>
        <Link to={subtitle.pageUrl}>{subtitle.pageTitle}</Link>
      </li>
    ))

    return (
      <div key={title.categoryTitle} className="sitemap__nav">
        <p className="sitemap__title">{title.categoryTitle}</p>
        <ul>{subInfo}</ul>
      </div>
    )
  })

  return (
    <Layout
      metaData="sitemap"
      metaDataCustom={{
        canonicalUrl,
        pageTitle,
        metaDescription,
        openGraph,
        metaRobots
      }}
      noHeader
      noFooter
      dropInHeader={dropInHeader}
      pageCategory="sitemap"
      v3Styles
    >
      <div className="sitemap__container">
        <p className="sitemap__header">{siteMapTitle}</p>
        {titles}
      </div>
    </Layout>
  )
}

export default SitemapV3
